function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Third Party Imports
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'; // Artifactory Imports

import { SVGIcon } from '@homeaway/react-svg'; // Primary Imports

import { MESSAGE_TYPE, ANIMATION_TYPE, SETTINGS, inlineMessageUtil } from './utils/inlineMessageUtil'; // styles

import "./InlineMessageStateless.css";

var InlineMessageStateless = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InlineMessageStateless, _Component);

  function InlineMessageStateless(props) {
    var _this;

    _this = _Component.call(this, props) || this; // hash of timeouts if needed for cancelling

    _this.addAnimationTimeout = function () {
      var noAnimation = _this.props.animationType.noAnimation;

      _this.clearAndDeleteTimeouts(ANIMATION_TYPE.TRANSITION);

      _this.timeouts[ANIMATION_TYPE.TRANSITION] = setTimeout(function () {
        delete _this.timeouts[ANIMATION_TYPE.TRANSITION];
      }, noAnimation ? 0 : SETTINGS.TRANSITION_DURATION);
    };

    _this.addShakeTimeout = function () {
      _this.clearAndDeleteTimeouts(ANIMATION_TYPE.SHAKE);

      _this.timeouts[ANIMATION_TYPE.SHAKE] = setTimeout(function () {
        if (_this.props.shakeTimeoutCallback) {
          _this.props.shakeTimeoutCallback();
        }

        delete _this.timeouts[ANIMATION_TYPE.SHAKE];
      }, SETTINGS.SHAKE_DURATION);
    };

    _this.timeouts = {};
    return _this;
  }

  var _proto = InlineMessageStateless.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        animate = _this$props.animate,
        shake = _this$props.shake;

    if (shake) {
      this.addShakeTimeout();
    } else if (animate) {
      this.addAnimationTimeout();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var currentlyShaking = !!this.timeouts[ANIMATION_TYPE.SHAKE];
    var currentlyAnimating = !!this.timeouts[ANIMATION_TYPE.TRANSITION];

    if (currentlyShaking) {
      if (this.props.shakeTimeoutCallback) {
        this.props.shakeTimeoutCallback();
      }

      this.clearAndDeleteTimeouts(ANIMATION_TYPE.SHAKE);
    }

    if (currentlyAnimating) {
      this.clearAndDeleteTimeouts(ANIMATION_TYPE.TRANSITION);
    }
  };

  _proto.clearAndDeleteTimeouts = function clearAndDeleteTimeouts(type) {
    clearTimeout(this.timeouts[type]);
    delete this.timeouts[type];
  };

  // eslint-disable-next-line complexity
  _proto.getClassNames = function getClassNames(prefix) {
    var _classnames;

    var _this$props2 = this.props,
        animate = _this$props2.animate,
        animationType = _this$props2.animationType,
        prevType = _this$props2.prevType,
        type = _this$props2.type;
    var anyToNone = animationType.anyToNone,
        helpToIcon = animationType.helpToIcon,
        iconToHelp = animationType.iconToHelp,
        iconToIcon = animationType.iconToIcon,
        iconToNone = animationType.iconToNone,
        noAnimation = animationType.noAnimation,
        noneToAny = animationType.noneToAny,
        noneToIcon = animationType.noneToIcon;
    var isAnimating = animate;
    return classnames('', (_classnames = {}, _classnames["" + prefix + type] = type, _classnames["" + prefix + prevType + "-to-" + type] = isAnimating, _classnames[prefix + "icon-to-icon"] = isAnimating && iconToIcon, _classnames[prefix + "icon-to-help"] = isAnimating && iconToHelp, _classnames[prefix + "help-to-icon"] = isAnimating && helpToIcon, _classnames[prefix + "icon-to-none"] = isAnimating && iconToNone, _classnames[prefix + "none-to-icon"] = isAnimating && noneToIcon, _classnames[prefix + "any-to-none"] = isAnimating && anyToNone, _classnames[prefix + "none-to-any"] = isAnimating && noneToAny, _classnames[prefix + "no-animation"] = noAnimation, _classnames));
  } // eslint-disable-next-line complexity
  ;

  _proto.render = function render() {
    var _this$props3 = this.props,
        animate = _this$props3.animate,
        ariaLive = _this$props3.ariaLive,
        id = _this$props3.id,
        inverse = _this$props3.inverse,
        nextMessage = _this$props3.message,
        prevMessage = _this$props3.prevMessage,
        prevType = _this$props3.prevType,
        shake = _this$props3.shake,
        nextType = _this$props3.type;
    var wrapperClassNames = classnames('InlineMessageStateless', {
      'InlineMessageStateless--shake': shake,
      'text-white': inverse
    }); // if animating out (i.e. going to no message or help), still show the previous icon

    var iconMarkup = inlineMessageUtil.getIconMarkup({
      type: nextType,
      prevType: prevType,
      animate: animate
    });
    var iconType = inlineMessageUtil.getIconTypeToUse({
      type: nextType,
      prevType: prevType,
      animate: animate
    });
    var iconClassNames = classnames('InlineMessageStateless__icon', 'InlineMessageStateless--small-text', 'small', this.getClassNames('InlineMessageStateless__icon--'), {
      'text-info': iconType === MESSAGE_TYPE.INFO && !inverse,
      'text-success': iconType === MESSAGE_TYPE.SUCCESS && !inverse,
      'text-danger': iconType === MESSAGE_TYPE.ERROR && !inverse,
      'text-warning': iconType === MESSAGE_TYPE.WARN && !inverse
    }); // if animating out (i.e. going to no message), still show the previous message

    var message = animate && nextType === MESSAGE_TYPE.NONE ? prevMessage : nextMessage;
    var messageClassNames = classnames('InlineMessageStateless__message', 'InlineMessageStateless--small-text', 'small', this.getClassNames('InlineMessageStateless__message--'), {
      'InlineMessageStateless__message--same-message': prevMessage === nextMessage && nextType !== MESSAGE_TYPE.NONE
    });
    var typeRequiresAriaLive = [nextType === MESSAGE_TYPE.ERROR, nextType === MESSAGE_TYPE.SUCCESS, nextType === MESSAGE_TYPE.INFO, nextType === MESSAGE_TYPE.WARN].some(function (condition) {
      return !!condition;
    });
    var messageIsString = typeof message === 'string';

    var messageProps = _extends({
      id: id
    }, typeRequiresAriaLive && message !== '' && {
      role: 'alert',
      'aria-live': ariaLive
    });

    return /*#__PURE__*/React.createElement("div", {
      className: wrapperClassNames
    }, iconMarkup && /*#__PURE__*/React.createElement(SVGIcon, {
      className: iconClassNames,
      markup: iconMarkup
    }), message && messageIsString && /*#__PURE__*/React.createElement("span", _extends({}, messageProps, {
      className: messageClassNames,
      dangerouslySetInnerHTML: {
        __html: message
      }
    })), message && !messageIsString && /*#__PURE__*/React.createElement("div", _extends({}, messageProps, {
      className: messageClassNames
    }), message));
  };

  return InlineMessageStateless;
}(Component);

InlineMessageStateless.propTypes = {
  /** Should the message animate; should be passed in conjunction with a new key value to reset the component. */
  animate: PropTypes.bool,

  /** Animation type to use; selected from object of options */
  animationType: PropTypes.shape({
    iconToIcon: PropTypes.bool,
    iconToHelp: PropTypes.bool,
    helpToIcon: PropTypes.bool,
    iconToNone: PropTypes.bool,
    noneToIcon: PropTypes.bool,
    anyToNone: PropTypes.bool,
    noneToAny: PropTypes.bool,
    noAnimation: PropTypes.bool,
    type: PropTypes.string
  }),

  /** The aria-live value for the alert.
   * 'polite' - indicates that the screen reader should wait until the user is idle before presenting updates to the user
   * 'assertive' may interupt user's flow
   */
  ariaLive: PropTypes.oneOf(['assertive', 'polite']),

  /** The message's id, required for a11y */
  id: PropTypes.string.isRequired,

  /** Flag to make message text use white text for better a11y contrast when used on dark backgrounds */
  inverse: PropTypes.bool,

  /** The content of the message */
  message: PropTypes.node,

  /** The previous type of message; used for applying class `.typeX-to-typeY` */
  prevType: PropTypes.oneOf(['danger', 'help', 'info', 'none', 'success', 'warn']),

  /** Should the message shake. */
  shake: PropTypes.bool,

  /** The type of message */
  type: PropTypes.oneOf(['danger', 'help', 'info', 'none', 'success', 'warn'])
};
InlineMessageStateless.defaultProps = {
  animate: false,
  animationType: {},
  ariaLive: 'polite',
  inverse: false,
  message: '',
  prevType: 'help',
  shake: false,
  type: 'help'
};
export default InlineMessageStateless;
//# sourceMappingURL=InlineMessageStateless.js.map